module.exports = __webpack_public_path__ + "static/11-773dadc13713fb8722fcc6aa3dbeec89.png";